import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import Team from './components/Team';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navigation from './components/Navigation';
import CookieConsent from '../../components/feature/CookieConsent';
import SEO from '../../components/feature/SEO';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://dulair.com';

const homeSchema = [
  {
    '@type': 'WebSite',
    '@id': `${siteUrl}/#website`,
    name: 'Dulair Private Family Office',
    url: siteUrl,
  },
  {
    '@type': ['FinancialService', 'Organization'],
    '@id': `${siteUrl}/#organization`,
    name: 'Dulair Private Family Office',
    url: siteUrl,
    description:
      'Premier private family office specializing in property investments, healthcare ventures, and strategic investments for high-net-worth individuals and sophisticated investors across the UK.',
    telephone: '+44-203-151-0000',
    email: 'enquiries@dulairpfo.com',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Kings Head House, 15 London End',
      addressLocality: 'Beaconsfield',
      addressRegion: 'Buckinghamshire',
      postalCode: 'HP9 2HN',
      addressCountry: 'GB',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 51.6079,
      longitude: -0.6476,
    },
    areaServed: {
      '@type': 'Country',
      name: 'United Kingdom',
    },
    knowsAbout: [
      'Property Investment',
      'Healthcare Investment',
      'Wealth Management',
      'Private Family Office',
      'High Net Worth Investment',
    ],
  },
];

const HomePage = () => {
  const [scrolled, setScrolled] = useState(false);
  const [showBackToTop, setShowBackToTop] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
      setShowBackToTop(window.scrollY > 400);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (location.state?.scrollTo === 'footer') {
      setTimeout(() => {
        const footer = document.getElementById('footer');
        if (footer) {
          footer.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 300);
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="bg-white">
      <SEO canonical="/" schema={homeSchema} />
      <Navigation scrolled={scrolled} />
      <Hero />
      <About />
      <Services />
      <Portfolio />
      <Team />
      <Contact />
      <Footer />
      <CookieConsent />

      {/* Back to Top Button */}
      <button
        onClick={scrollToTop}
        className={`fixed bottom-24 right-6 z-50 w-12 h-12 flex items-center justify-center bg-gold/60 hover:bg-gold/80 text-navy rounded-full shadow-lg transition-all duration-300 cursor-pointer backdrop-blur-sm ${
          showBackToTop ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
        aria-label="Back to top"
      >
        <i className="ri-arrow-up-line text-xl"></i>
      </button>
    </div>
  );
};

export default HomePage;
